/*
    Made by : Samuel
    date :
 */

// ----------------------------------------------------------------------------- //
// IMPORTS //

import NotFoundWrapper from "../components/NotFound/NotFoundWrapper";
import NotFoundText from "../components/NotFound/NotFoundText";

// ----------------------------------------------------------------------------- //
// PROPS //

// ----------------------------------------------------------------------------- //
// COMPONENT //

const NotFound = () => {
    return (
        <NotFoundWrapper>
            <NotFoundText />
        </NotFoundWrapper>
    );
};

// ----------------------------------------------------------------------------- //
// EXPORTS //

export default NotFound;

// ----------------------------------------------------------------------------- //
